// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._1di6r5ow:active{background-color:#a6c5e229}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/media-ui/dist/esm/customMediaPlayer/playbackSpeedControls.compiled.css"],"names":[],"mappings":"AAAA,kBAAkB,0BAA0B","sourcesContent":["._1di6r5ow:active{background-color:#a6c5e229}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
